<template>
  <a-collapse v-model="activeKey" class="interests-section">
    <a-collapse-panel v-a11y-tab.element :header="$t('interests.section')">
      <slot />
      <completion-indicator
        :percent="fillPercentageInterests"
        slot="extra"
        class="completion-indicator"
        :showClose="false"
      />
    </a-collapse-panel>
  </a-collapse>
</template>

<script>
import { mapGetters } from 'vuex';
import CompletionIndicator from '@/components/account/targetingInfo/CompletionIndicator.vue';

export default {
  data() {
    return {
      activeKey: [],
    };
  },
  components: {
    CompletionIndicator,
  },
  computed: {
    ...mapGetters(['fillPercentageInterests']),
  },
};
</script>

<style lang="scss" scoped>
.completion-indicator {
  border: none;
  background: none;
  margin-left: 10px;
}
</style>

<style lang="scss">
@import '~@/assets/styles/fonts';

.interests-section {
  margin: 50px 0;

  .ant-collapse-extra {
    float: none !important;
  }
  .ant-collapse-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    font-size: $font-size-large;
    font-weight: bold;
  }
  .ant-collapse-extra {
    font-weight: 400;
  }
}
</style>
